import Axios from 'axios';
import { getEnv } from 'common/utils';
import { fastApiErrorHandler, fastApiResponseHandler } from 'common/service/utils/fastApiHandler';
import { trnansformUrlInterceptor } from 'common/service/utils/trnansformUrl';
export * from 'common/service/utils/URLGroup';

export const FastApiAxiosInstance = Axios.create({
  baseURL: '/fastApi',
  headers: {
    'x-device-platform': 'web',
  },
});

FastApiAxiosInstance.interceptors.response.use(fastApiResponseHandler, fastApiErrorHandler);
FastApiAxiosInstance.interceptors.request.use(trnansformUrlInterceptor);

// 业务任务，不区分内外平台的接口
export const WHITE_LIST_INNER_OUTER = [
  'getProjectRoleOptions',
  'getUserRoleInfo',
  'getProjectRule',
  'addProjectUser',
  'updateProjectUserRole',
  'removeProjectUserRole',
  'getParentTemplateInfo',
  'addParentTemplate',
  'removeParentTemplate',
  'getLauncherOptions',
  'createParentTaskWithTemplate',
  'getProjects',
  'getTasks',
  'getTaskNumOverview',
  'getTaskVersion',
  'getParentTemplateInstanceList',
  'getParentTaskInfo',
  'getTaskCurrentVersionFile',
  'getVersionList',
  'getReviews',
  'getTaskInfo',
  'getTaskCurrentVersionFile',
  'updateVersionStatus',
  'listBackgroundVersion',
  'biddenList',
  'biddenStatusNum',
];

export const getNormalParams = (requestName) => {
  const isIgnoreType = WHITE_LIST_INNER_OUTER.includes(requestName);
  const type = getEnv()?.isInternal ? 'INNER' : 'OUTER';
  return isIgnoreType ? {} : { type };
};
